import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock, CheckCircle2, Wallet } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ZertifikatFreigabe = ({ teilnehmerId, anhaengeAnzahl, onDokumente }) => {
  const [f, setF] = useState(null);
  const { user } = useAuth();
  const darf = ["gf", "verwaltung"].includes(user?.role);
  const laden = useCallback(() => {
    axios.get(`${API}/teilnehmer/${teilnehmerId}/zertifikat-freigabe`).then((r) => setF(r.data)).catch(() => setF(null));
  }, [teilnehmerId]);
  useEffect(() => { laden(); }, [laden, anhaengeAnzahl]);

  const trotzdem = async () => {
    const grund = window.prompt("Zertifikat trotz offener Zahlung freigeben – Grund (z. B. Ratenvereinbarung, Zusage Pflegedienst):");
    if (!grund || !grund.trim()) return;
    try {
      await axios.post(`${API}/teilnehmer/${teilnehmerId}/zertifikat-zahlung-freigabe`, { grund });
      toast.success("Zertifikat freigegeben – im Verlauf protokolliert");
      laden();
    } catch (err) { toast.error(err.response?.data?.detail || "Freigabe fehlgeschlagen"); }
  };

  if (!f || (f.rezert && f.freigegeben)) return null;
  if (f.freigegeben) {
    return (
      <div className="flex items-center gap-2 text-sm text-stone-700 rounded-lg border border-stone-200 bg-white px-3 py-2" data-testid="zertifikat-freigegeben">
        <CheckCircle2 size={16} className="text-emerald-600" />
        {f.zahlung_override
          ? `Zertifikat-Druck freigegeben – trotz offener Zahlung freigegeben von ${f.zahlung_override.von} (${f.zahlung_override.grund}).`
          : "Zertifikat-Druck freigegeben: alle Unterlagen vorhanden, bei Selbstzahlern/Pflegediensten ist die Zahlung eingegangen."}
      </div>
    );
  }
  const nurZahlung = (f.zahlung_fehlt || []).length > 0 && f.fehlt.length === f.zahlung_fehlt.length;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-[#F0C9B8] bg-[#FBEDE7] px-4 py-3" data-testid="zertifikat-gesperrt">
      <div className="flex items-center gap-2 text-sm text-stone-900">
        {nurZahlung ? <Wallet size={16} className="text-[#B4502F]" /> : <Lock size={16} className="text-[#B4502F]" />}
        <span><b>Zertifikat-Druck gesperrt.</b> Es fehlt: {f.fehlt.join(", ")}.{f.zahlung_fehlt?.length ? " Sobald die Zahlung gebucht ist, wird automatisch freigegeben." : ""}</span>
      </div>
      <div className="flex gap-4">
        {f.zahlung_fehlt?.length > 0 && darf && (
          <button onClick={trotzdem} className="text-sm font-medium text-stone-700 hover:underline" data-testid="zertifikat-trotzdem-freigeben">Trotzdem freigeben</button>
        )}
        {!nurZahlung && <button onClick={onDokumente} className="text-sm font-medium text-[#B4502F] hover:underline" data-testid="zertifikat-zu-dokumenten">Jetzt ergänzen</button>}
      </div>
    </div>
  );
};
